import { render, staticRenderFns } from "./StockCorrectionItems.vue?vue&type=template&id=23ee0007&scoped=true&"
import script from "./StockCorrectionItems.vue?vue&type=script&lang=ts&"
export * from "./StockCorrectionItems.vue?vue&type=script&lang=ts&"
import style0 from "./StockCorrectionItems.vue?vue&type=style&index=0&id=23ee0007&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ee0007",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCombobox,VSimpleTable,VTextField})
